export default {
  intl: 'https://www.instagram.com/nuinalpbr',
  'pt-br': 'https://www.instagram.com/nuinalpbr',
} as const;
